<template>
    <div class="main-container">
        <div class="background-container">
            <div class="background-stripe-alpha">
                <div class="background-stripe">
                </div>
            </div>
            <div class="background-color">
            </div>
        </div>
        <div style="background-color: #ffffff;" class="lottery-container">
            <van-image :src="require('../../assets/images/lotteryLogo.png')" style="width: 100%;"/>
            <span class="lottery-text">还有{{activityInfo.lottery_frequency}}次抽奖机会</span>
            <LuckyWheel
            ref="LuckyWheel"
            :blocks="spinOption.blocks"
            :prizes="spinOption.prizes"
            :buttons="spinOption.buttons"
            width="9rem"
            height="9rem"
            :default-config="spinOption.defaultConfig"
            @start="startCallBack"
            @end="endCallBack"
            />
            <div class="mid-flex" style="width: 100%;margin: 20px;">
                <div class="lottery-info-button mid-flex" @click="startRecordList">查询中奖记录</div>
            </div>
        </div>
        <van-popup v-model="lotteryRecordSwitch" round position="bottom">
            <div class="record-list-title">
                <span>中奖记录</span>
            </div>
            <van-cell-group class="record-list-content">
                <van-empty v-if="lotteryRecordList.length <= 0" description="还没任何记录" />
                <van-cell title="item" value="item" v-for="(item, index) in lotteryRecordList" :key="'record'+index">
                    <template #title>
                        <div class="record-info">
                            <van-image
                                width="45"
                                height="45"
                                :src="item.prize_image_url"/>
                            <span class="record-name">{{item.prize_name}}</span>
                        </div>
                    </template>
                    <template>
                        <div class="record-option">
                            <span class="record-name">中奖时间<br>{{item.lottery_time}}</span>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-popup>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import api from "../../assets/js/api";
    export default {
        name: "SpinLottery",
        data(){
            return {
                isLoading: false,
                spinOption: {
                    blocks: [
                        { padding: '10px', background: '#ffc27a' },
                        { padding: '10px', background: '#ff4a4c' },
                        { padding: '0px', background: '#fff' }
                    ],
                    prizes: [
                    ],
                    buttons: [
                        { radius: '40px', background: '#d64737' },
                        { radius: '35px', background: '#f6c66f', pointer: true },
                        {
                            radius: '30px',
                            background: '#fdac42',
                            fonts: [{ text: '开始', top: '-13px', fontColor: '#fff' }]
                        }
                    ],
                    defaultConfig: { gutter: '5px' },
                },
                prizeResultList: {},
                prizeInfo: {},
                prizeInfoList: [],
                activityInfo: {},
                lotteryRecordSwitch: false,
                lotteryRecordList: []
            };
        },
        created() {
            let self = this;
            api.request('/activity/detail', {
                'id' : this.$route.query.id,
            }).then(res => {
                self.activityInfo = res.data;
                let prizes = [];
                let prizeNum = 5 > res.data.prize.length - 1 ? 5 : res.data.prize.length;
                for (let counter = 0; counter <= prizeNum ; counter++ ) {
                    prizes.push({
                        title: res.data.prize[counter % res.data.prize.length].name,
                        background: counter % 2 ? '#f9e3bb' : '#f8d384',
                        fonts: [{ text: res.data.prize[counter % res.data.prize.length].name, top: '10%', fontSize: '0.4rem' }],
                        imgs:[{ src: `${res.data.prize[counter % res.data.prize.length].image_url}`, width: '30%', height: '50%', top: '35%' }],
                    })

                    if (self.prizeResultList[res.data.prize[counter % res.data.prize.length].name] === undefined) {
                        self.prizeResultList[res.data.prize[counter % res.data.prize.length].name] = [counter]
                    } else {
                        self.prizeResultList[res.data.prize[counter % res.data.prize.length].name].push(counter)
                    }
                }
                self.spinOption.prizes = prizes;
            })
        },
        methods: {
            startCallBack () {
                if (this.isLoading) return
                let self = this;
                this.isLoading = true;
                api.request('/activity/lottery', {
                    'id' : this.$route.query.id,
                }).then(res => {
                    self.activityInfo.lottery_frequency -= 1;
                    let prizeIndex = self.prizeResultList[res.data.user_lottery.prize_info.name][Math.floor(Math.random() * self.prizeResultList[res.data.user_lottery.prize_info.name].length)]
                    self.$refs.LuckyWheel.play()
                    setTimeout(() => {
                        self.$refs.LuckyWheel.stop(prizeIndex)
                    }, 3000)
                }).catch(err=> {
                    self.$dialog.alert({message: err.msg})
                }).finally(() => {
                    self.isLoading = false;
                })
            },
            endCallBack (prize) {
                this.$dialog.alert({message: `恭喜你获得"${prize.title}"`})
            },
            startRecordList() {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                this.lotteryRecordList = [];
                let toast = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/activity/winning_record', {id : this.$route.query.id}).then(res => {
                    self.lotteryRecordList = res.data
                    self.lotteryRecordSwitch = true;
                    self.$toast.clear(true);
                }).catch(res => {
                    self.$toast.clear(true);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.loading = false;
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .main-container {
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }

    .title{
        padding: 15px 0 20px 15px;
        font-size: 20px;
        background-color: #ffffff;
        font-weight: bold;
    }

    .lottery-container {
        z-index: 1000;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;

        .lottery-text {
            z-index: 10;
            font-size: 20px;
            color: #fff;
            font-weight: bold;
            text-align: center;
            padding: 15px;
            letter-spacing: 5px;
            font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;
        }

        .lottery-info-button {
            z-index: 10;
            width: 60%;
            background: linear-gradient(90deg, rgb(255, 202, 88), rgb(255, 163, 87));
            font-size: 16px;
            color: #fff;
            box-shadow: 0 0 30px rgb(248, 169, 49);
            line-height: 40px;
            letter-spacing: 5px;
            border-radius: 20px;
        }
    }

    .mid-flex {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .background-container {
        z-index: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        .background-stripe-alpha {
            height: 40%;
            background: linear-gradient(135deg,  #ffb223 25%, #ff8c40 0,#ff8c40 50%,#ffb223 0%,#ffb223 75%,#ff8c40 0);
            background-size: 1.5rem 1.5rem;
            .background-stripe {
                height: 100%;
                background-image: linear-gradient(rgba(255, 214, 126, 0),rgba(255, 214, 126, 1));
            }
        }

        .background-color {
            height: 60%;
            background: linear-gradient(rgba(255, 214, 126, 1), rgb(255, 255, 230));
        }
    }

    .record-list-title {
        width: 100%;
        height: 1.5rem;
        border: 1px solid #ddd;
        span {
            line-height: 1.5rem;
            display: block;
            text-align: center;
            color: #999;
            font-size: 16px;
        }
    }

    .record-list-content {
        height: 80vh;
        overflow-y: auto;
        .record-info {
            display: flex;
            justify-content: start;
            align-items: center;
            .record-name {
                font-size: 14px;
                color: #666;
                margin-left: 15px;
            }
        }
        .record-option {
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/activity/SpinLottery.vue